module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "author"
  }, [_vm._v("3")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('span', [_vm._v("Ich weiß")]), _vm._v(" nicht, wie du\nsingest,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nmein Meister, ich lausche immer in stillem Staunen.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Dein Licht der Musik erleuchtet die"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nWelt. Der Lebenshauch deiner Musik"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nläuft von Himmel zu Himmel. Der heilige"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nStrom der Musik durchbricht alle Hindernisse"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nvon Stein und stürzet fort.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Mein Herz ersehnt, deinem Sang sich"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nzu einen und ringt umsonst nach Stimme."), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nIch wollte sprechen, doch Sprache fügt"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nsich dem Sang nicht, da schrei ich getäuscht"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nauf! O du hast mein Herz gefangen"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nin deines Liedes endlosen Maschen, mein"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nMeister. "), _c('a', {
    attrs: {
      "id": "page6",
      "title": "wedi/cal"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0